import type { DocumentItem } from 'src/components/pages/info/document/index/types'

type Translate = (_text: string) => string

export default function getKgDocuments(staticPath: string, translate: Translate): DocumentItem[] {
  const base = `${staticPath}_v1/ydoc/documents/info/kg`

  return [
    {
      id: 'kg-branch-1',
      title: translate('Филиал в Кыргызстане страница 1'),
      alt: translate('Филиал в Кыргызстане страница 1'),
      previewSrc: `${base}/Филиал_в_Кыргызстане_1.png`,
      src: `${base}/Филиал_в_Кыргызстане_1.png`,
    },
    {
      id: 'kg-branch-2',
      title: translate('Филиал в Кыргызстане страница 2'),
      alt: translate('Филиал в Кыргызстане страница 2'),
      previewSrc: `${base}/Филиал_в_Кыргызстане_2.png`,
      src: `${base}/Филиал_в_Кыргызстане_2.png`,
    },
  ]
}
